import {
  ApiResponse,
  KYCCasesListResponse,
  MessageResponse,
  PostIdentDataResponse,
  KYCExtractResponse,
  MrzExtractionRunResponse,
} from '@mygate/common';
import { api } from './api';

class KycService {
  /**
   * Get all KYC cases for a user
   */
  async getUserKycCases(userId: string): Promise<ApiResponse<KYCCasesListResponse>> {
    return api.get(`/api/staff/users/${userId}/kyc-cases`);
  }

  /**
   * Set KYC case as active for user
   */
  async setActiveKycCase(userId: string, caseId: string): Promise<ApiResponse<MessageResponse>> {
    return api.put(`/api/staff/users/${userId}/kyc-cases/${caseId}/set-active`);
  }

  /**
   * Fetch fresh PostIdent data for a KYC case
   */
  async fetchPostIdentData(caseId: string): Promise<ApiResponse<PostIdentDataResponse>> {
    return api.get(`/api/staff/kyc-cases/${caseId}/postident-data`);
  }

  /**
   * Force extract KYC data from PostIdent
   */
  async forceExtractKycData(caseId: string): Promise<ApiResponse<KYCExtractResponse>> {
    return api.post(`/api/staff/kyc-cases/${caseId}/extract`);
  }

  /**
   * Download the result PDF for a KYC case
   * Returns the PDF as a blob for download
   */
  async downloadResultPdf(caseId: string): Promise<Blob> {
    return api.fetchBlob(`/api/staff/kyc-cases/${caseId}/result-pdf`);
  }

  /**
   * Run MRZ extraction pipeline on a KYC case PDF
   */
  async runMrzExtraction(caseId: string): Promise<ApiResponse<MrzExtractionRunResponse>> {
    return api.post(`/api/staff/kyc-cases/${caseId}/run-mrz-extraction`);
  }
}

export const kycService = new KycService();
